module.exports = __webpack_public_path__ + "img/benefit-payout.77cf17dd.jpg";